import React, { useEffect, useState } from "react";
// import { Box, AppBar, Toolbar, IconButton, Typography } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
import NavDrawer from "../../NavDrawer/NavDrawer";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { app, auth } from "../../../scripts/app";
// import classes from './header.module.css'
import * as classes from './header.module.css'

export default function Header() {
	const [open, setOpen] = useState(false);
	const nav = useNavigate();
	const toggleDrawer = (newOpen) => {
		if(newOpen === open) return 
		setOpen(newOpen);
		console.log("set drawer to: ", newOpen, "From: ", open);
	};

	useEffect(() => {
		if (open) setOpen(false);
	  }, [location.pathname]);

	const handleLogout = () => {
		signOut(auth)
			.then(() => {
				// Sign-out successful.
				nav("/");
				console.log("Signed out successfully");
			})
			.catch((error) => {
				// An error happened.
			});
	};


	return (
		<>
			{/* <Box sx={{ flexGrow: 0 }} color="#272333"> */}
			{/* <AppBar
          position="static"
          sx={{ backgroundColor: "#272333" }}
          enableColorOnDark
        >
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={() => toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Launchpad
            </Typography>
            <IconButton
              size="large"
              aria-label="display more actions"
              edge="end"
              color="inherit"
              onClick={() => nav('/')}
            >
              <svg id="log-out" width="30" viewBox="0 0 24 24">
                <path
                  fill="white"
                  d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z"
                ></path>
              </svg>
            </IconButton>
          </Toolbar>
        </AppBar> */}
			<header className={classes.header}>
				{/* <button > */}
				<svg
					id="menu-icon"
					className={classes.menuIcon}
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					height="2rem"
					onClick={() => toggleDrawer(true)}
				>
					<path
						fill="white"
						d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"
					></path>
				</svg>
				{/* </button> */}
				<div className={classes.headerLogo} id="rtk-logo"></div>
				{/* <button > */}
				<svg style={{cursor:'pointer'}} id="log-out" width="30" viewBox="0 0 24 24" onClick={handleLogout}>
					<path
						fill="white"
						d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z"
					></path>
				</svg>
				{/* </button> */}
			</header>
			<NavDrawer toggleDrawer={toggleDrawer} open={open} />
			{/* </Box> */}
		</>
	);
}
